enum BASIC {
  SET_TOKEN,
  SET_USER_INFO,
  SET_VIDEO_CHECK
}

export default BASIC
